module.exports = __webpack_public_path__ + "img/h_store.9ac5d48a.svg";